<template>
  <div class="tables-basic">
    <div v-if="loading" class="page-loading-container">
      <b-spinner label="Loading..." ></b-spinner>
    </div>
    <div v-else>

      <h2 class="page-title">Admin</h2>


      <b-row v-if="user">
        <b-col>
          <Widget
                  title="User Details"
          >
           {{user.email}}
            <p>
              joined: {{user.date_joined}}
            </p>
            <p>
              Credits: {{user.credits}}
            </p>
            <b-form @submit.prevent="onSubmit">
            <b-form-group
                    id="fieldset-horizontal"
                    label-cols-sm="4"
                    label-cols-lg="2"
                    label="Add Credits"
                    label-for="input-horizontal"
            >
              <b-form-input id="input-horizontal" style="width:100px" v-model="creditAmount" type="number"></b-form-input>
            </b-form-group>
            <b-button type="submit" variant="primary"> <b-spinner small v-if="submitting"></b-spinner>Submit</b-button>
            </b-form>
          </Widget>
        </b-col>
      </b-row>


    </div>
  </div>
</template>

<script>
  import Widget from '@/components/Widget/Widget';
  import gql from "graphql-tag";
  import { mapState } from 'vuex';
  import axios from "axios";
  export default {
    name: 'Tables',
    components: { Widget },
    data() {
      return {
        user: '',
        creditAmount: 0,
        VUE_APP_DOMAIN_ROOT: process.env.VUE_APP_DOMAIN_ROOT,
        loading: true,
        submitting: false,
      };
    },
    computed: {
      ...mapState({activeSite: 'activeSite'}),
    },
    methods: {
      onSubmit(){
        this.submitting = true;
        axios
                .put(`admin/user/${this.$route.params.userid}`, {credits: this.creditAmount})
                .then(
                        response => {
                          return this.getStats();
                        },
                        _response => {
                          console.warn(_response);
                          return false;
                        }
                );
      },
      getStats(){
        axios
                .get(`admin/user/${this.$route.params.userid}`)
                .then(
                        response => {
                          this.loading = false;
                          this.submitting = false;
                          this.user = response.data.user;
                          return true;
                        },
                        _response => {
                          console.warn(_response);
                          return false;
                        }
                );

      },
      shareLink(website){
        axios
                .post(`websites/share/${website.uuid}`)
                .then(
                        response => {
                          website.share_link = response.data.data.id;
                          return response.data.data.id;
                        },
                        _response => {
                          return false;
                        }
                );
      },
    },
    created() {
      this.$watch("$route",() => { this.currentPage = this.$route.query.page || 1}, {
        immediate: true
      });
    },
    mounted() {
      this.getStats();
    }
  };
</script>

<style src="./CommandCenter.scss" lang="scss" scoped />
<style lang="scss">
  .link-redirect {
    font-size:9pt;
    color:gray;
    padding:4px;
  }
  .link-status-redirect{
    color:red;
    font-size:9pt;
    padding:4px;
  }
  .link-entry{
    max-width:580px;
    overflow:auto;
  }
  .broken-link-preview-image {
    border-radius: 50%;
    max-width: 250px;
    box-shadow: #bdc4e0 0px 0px 20px;
  }
</style>
